import { gql } from "apollo-server-micro";

export const VEHICLE_LIST_DATA_FRAGMENT = gql`
  fragment VehicleListData on Vehicle {
    _id
    user {
      _id
      username
      displayName
      image
      idVerified
    }
    pictures
    thumbs
    brand
    model
    price
    hidePrice
    currency
    year
    category
    mileageUnit
    mileage
    fuel
    transmission
    drivetrain
    location {
      country
      province
      municipality
    }
    condition
    receivesAnotherVehicle
    negotiable
    tags
    listingTier
    createdDate
    expires
    youtubeLink
    isFeatured
    slug
  }
`;
